<template>
  <div class="flex flex-col items-center w-full gap-4 pb-6 pt-2">
    <LottieAnimation
      ref="anim"
      :animationData="appUpdate"
      :autoPlay="true"
      :loop="false"
      :speed="1"/>

    <h2 class="text-2xl font-bold text-center text-surface-900">
      גרסה חדשה זמינה!
    </h2>

    <p class="text-base text-center text-surface-500 leading-relaxed max-w-[280px]">
      עדכנו את האפליקציה כדי לשפר את הביצועים ולהוסיף תכונות חדשות.
    </p>

    <Button
      label="עדכנו עכשיו"
      class="w-full h-12 mt-2 text-lg font-semibold"
      @click="handleUpdate"
    />

    <button
      class="text-surface-400 text-sm underline mt-1"
      @click="handleLater"
    >
      אחר כך
    </button>
  </div>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import { useAppUpdate } from '@app/composables/app-update';
import { useDrawer } from '@torim-app/shared-components';
import { LottieAnimation } from 'lottie-web-vue';
import appUpdate from '../../../../assets/animations/app_update.json'

const { runAppUpdate } = useAppUpdate();
const { closeDrawer } = useDrawer();

const handleUpdate = async () => {
  await runAppUpdate();
  if (Capacitor.getPlatform() === 'ios') {
    closeDrawer();
  }
};

const handleLater = () => {
  closeDrawer();
};
</script>
